// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.googlemaps.RentalManagerGoogleMapsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GoogleMapsSignedUrlResponseDto,
  GoogleMapsSignUrlRequestDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

export interface RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Args {
  postData: GoogleMapsSignUrlRequestDto;
}

export type RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Options = UseMutationOptions<
  GoogleMapsSignedUrlResponseDto,
  unknown,
  RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Args
>;

/**
 * Add GoogleMap signature and key to URL
 */
export const useRentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl = ({
  httpClient,
  ...options
}: Omit<RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Args) =>
      RentalManagerGoogleMapsWebApiHandler_addSignatureAndKeyToUrl(args.postData, httpClient),
  });
};
